export { default as Img200 } from './processed/200/thurston_cover.jpg';
export { default as Img400 } from './processed/400/thurston_cover.jpg';
export { default as Img600 } from './processed/600/thurston_cover.jpg';
export { default as Img800 } from './processed/800/thurston_cover.jpg';
export { default as Img1000 } from './processed/1000/thurston_cover.jpg';
export { default as Imgthumb } from './processed/thumb/thurston_cover.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/thurston_cover.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/thurston_cover.jpg';
export const ImgData = { width: 648, height: 1007, ratio: 1.5540123456790123, orientation: 'portrait' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      182,
      116,
      52
    ],
    "_population": 3,
    "_hsl": [
      0.08205128205128205,
      0.5555555555555555,
      0.45882352941176474
    ]
  },
  "LightVibrant": {
    "_rgb": [
      221,
      196,
      118
    ],
    "_population": 98,
    "_hsl": [
      0.1262135922330097,
      0.6023391812865497,
      0.6647058823529413
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      112,
      76,
      48
    ],
    "_population": 2,
    "_hsl": [
      0.07291666666666667,
      0.4,
      0.3137254901960784
    ]
  },
  "Muted": {
    "_rgb": [
      152,
      172,
      92
    ],
    "_population": 2,
    "_hsl": [
      0.20833333333333334,
      0.32520325203252043,
      0.5176470588235295
    ]
  },
  "LightMuted": {
    "_rgb": [
      207,
      196,
      165
    ],
    "_population": 8,
    "_hsl": [
      0.12301587301587304,
      0.3043478260869565,
      0.7294117647058824
    ]
  },
  "DarkMuted": {
    "_rgb": [
      46,
      88,
      69
    ],
    "_population": 1102,
    "_hsl": [
      0.4246031746031746,
      0.3134328358208955,
      0.2627450980392157
    ]
  }
};



// WEBPACK FOOTER //
// ./src/content/images/thurston_cover.js